<div class="mb-4">
  <!-- <fieldset>/<legend> rather than role="group": the tab strip is a group of native controls,
       so the semantics come from the element itself and the label stays available to AT. -->
  <fieldset class="min-w-0 border-0 p-0">
    <legend class="sr-only">{{ 'modules.profile_settings.tabs_label' | translate }}</legend>
    <div class="-mx-1 flex snap-x snap-mandatory gap-2 overflow-x-auto px-1 pb-1">
      @for (tab of tabs; track tab) {
      <button
        type="button"
        (click)="setActiveTab(tab.id)"
        [attr.aria-pressed]="tab.isActive"
        [ngClass]="{
          'bg-neutral-gray20': tab.isActive,
          'bg-white': !tab.isActive
        }"
        class="flex shrink-0 snap-start items-center whitespace-nowrap rounded-lg p-2.5 text-base font-medium text-neutral-gray70 transition-colors hover:bg-neutral-gray10 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-90 coarse:min-h-11">
        {{ tab.label | translate }}
        @if (tab.isComingSoon) {
        <span class="ml-2 text-xs text-neutral-gray40">
          ( {{ 'modules.profile_settings.subscription.coming_soon' | translate }} )
        </span>
        }
      </button>
      }
    </div>
  </fieldset>
</div>
